export default __webpack_public_path__ + "img/inform_report.c490a818.png";